  const customShippingDateFormatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
  });

  function isSunday(date) {
    return date.getDay() === 0;
  }

  function getNextWorkingDay(date) {
    const nextDay = new Date(date);
    nextDay.setDate(nextDay.getDate() + 1);
    if (isSunday(nextDay)) {
      nextDay.setDate(nextDay.getDate() + 1);
    }
    return nextDay;
  }

  function getDispatchDeadline() {
    const now = new Date();
    let deadline = new Date();
    deadline.setHours(17, 0, 0, 0);

    if (isSunday(deadline)) {
      deadline.setDate(deadline.getDate() + 1);
    } else if (now > deadline) {
      deadline.setDate(deadline.getDate() + 1);
      if (isSunday(deadline)) {
        deadline.setDate(deadline.getDate() + 1);
      }
    }

    return deadline;
  }

  function padNumber(number) {
    return number.toString().padStart(2, "0");
  }

  function formatTimeDifference(diff) {
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById("hours").textContent = padNumber(hours);
    document.getElementById("minutes").textContent = padNumber(minutes);
    document.getElementById("seconds").textContent = padNumber(seconds);
  }

  let customShippingAnimationFrameId = null;

  function updateCustomShippingCountdown() {
    try {
      const now = new Date();

      if (isSunday(now)) {
        document.getElementById("countdown-wrapper").style.display = "none";
        document.getElementById("dispatch-timing").textContent =
          "not available";
        customShippingAnimationFrameId = requestAnimationFrame(
          updateCustomShippingCountdown
        );
        return;
      }

      const deadline = getDispatchDeadline();
      const diff = deadline - now;

      if (diff < 0) {
        updateCustomShippingDates();
      }

      if (diff >= 0) {
        formatTimeDifference(diff);
      }

      customShippingAnimationFrameId = requestAnimationFrame(
        updateCustomShippingCountdown
      );
    } catch (error) {
      console.error("Countdown error:", error);
      document.getElementById("hours").textContent = "--";
      document.getElementById("minutes").textContent = "--";
      document.getElementById("seconds").textContent = "--";
    }
  }

  function updateCustomShippingDates() {
    try {
      const now = new Date();
      const orderDate = customShippingDateFormatter.format(now);
      const currentDay = now.getDay();
      const currentHour = now.getHours();

      let dispatchDate = new Date(now);
      let deliveryStart;
      let deliveryEnd;

      function skipSunday(date) {
        while (isSunday(date)) {
          date.setDate(date.getDate() + 1);
        }
        return date;
      }

      if (currentDay === 0) {
        dispatchDate = new Date(now);
        dispatchDate.setDate(dispatchDate.getDate() + 1);
        skipSunday(dispatchDate);
        deliveryStart = getNextWorkingDay(dispatchDate);
        deliveryEnd = getNextWorkingDay(deliveryStart);
      } else if (currentDay === 5) {
        dispatchDate = new Date(now);
        deliveryStart = new Date(dispatchDate);
        deliveryStart.setDate(deliveryStart.getDate() + 1);
        skipSunday(deliveryStart);
        deliveryEnd = new Date(deliveryStart);
        deliveryEnd.setDate(deliveryEnd.getDate() + 1);
        skipSunday(deliveryEnd);
      } else if (currentDay === 6) {
        dispatchDate = new Date(now);
        dispatchDate.setDate(dispatchDate.getDate() + 2);
        skipSunday(dispatchDate);
        deliveryStart = getNextWorkingDay(dispatchDate);
        deliveryEnd = getNextWorkingDay(deliveryStart);
      } else {
        if (currentHour >= 17) {
          dispatchDate = getNextWorkingDay(now);
        } else {
          dispatchDate = new Date(now);
        }
        deliveryStart = getNextWorkingDay(dispatchDate);
        deliveryEnd = getNextWorkingDay(deliveryStart);
      }

      const dispatchDateStr = customShippingDateFormatter.format(dispatchDate);
      const deliveryDates = `${customShippingDateFormatter.format(
        deliveryStart
      )} and ${customShippingDateFormatter.format(deliveryEnd)}`;

      document.getElementById("delivery-dates").textContent = deliveryDates;
      document.getElementById("order-date").textContent = orderDate;
      document.getElementById("dispatch-date").textContent = dispatchDateStr;
      document.getElementById("delivery-date").textContent = deliveryDates;

      const dispatchDayElement = document.getElementById("dispatch-day");
      const dispatchTimingElement = document.getElementById("dispatch-timing");
      if (dispatchDayElement && dispatchTimingElement) {
        const today = new Date();
        const dayDifference = Math.floor(
          (dispatchDate - today) / (1000 * 60 * 60 * 24)
        );
        if (dayDifference === 0) {
          dispatchDayElement.textContent = "today";
          dispatchTimingElement.textContent = "few hours";
        } else if (dayDifference === 1) {
          dispatchDayElement.textContent = "tomorrow";
          dispatchTimingElement.textContent = "next day";
        } else {
          dispatchDayElement.textContent = `${dayDifference} days later`;
          dispatchTimingElement.textContent = "after the weekend";
        }
      }
    } catch (error) {
      console.error("Date update error:", error);
    }
  }

  function initializeCustomShipping() {
    updateCustomShippingDates();
    updateCustomShippingCountdown();

    document.addEventListener("visibilitychange", () => {
      if (document.hidden && customShippingAnimationFrameId) {
        cancelAnimationFrame(customShippingAnimationFrameId);
      } else {
        updateCustomShippingCountdown();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCustomShipping);
  } else {
    initializeCustomShipping();
  }